import { useEffect, useState } from 'react';

export function message(error: unknown): string { return error instanceof Error ? error.message : 'Something went wrong. Please try again.'; }
export function useResource<T>(load: () => Promise<T>, key: string) {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<unknown>(null);
  const [version, setVersion] = useState(0);
  useEffect(() => {
    let live = true;
    setData(null); setError(null);
    load().then(value => { if (live) setData(value); }).catch(reason => { if (live) setError(reason); });
    return () => { live = false; };
  // The caller supplies the resource identity; load closures are deliberately not effect dependencies.
  }, [key, version]);
  return { data, error, reload: () => setVersion(v => v + 1) };
}
export function ResourceError({ error, retry }: { error: unknown; retry?: () => void }) {
  return <div role="alert" className="error">{message(error)} {retry && <button className="link" onClick={retry}>Try again</button>}</div>;
}
export function Loading() { return <p className="loading" role="status">Opening your notebook…</p>; }
export function Rich({ html, className }: { html: string; className?: string }) { return <span className={className} dangerouslySetInnerHTML={{ __html: html }} />; }
